var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdaptedWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.705,
    height: 40.605,
    viewBox: "0 0 42.705 40.605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.115 -2977.932)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M274.28,3331.412l-3.351-5.823.585-.339a.488.488,0,0,0,.017-.834l-3.925-2.494a.487.487,0,0,0-.75.434l.217,4.646a.488.488,0,0,0,.733.4l.416-.241,2.516,4.372-13.172-.018a1.564,1.564,0,1,0,0,3.128l14.836.019A2.167,2.167,0,0,0,274.28,3331.412Z",
    transform: "translate(-310.981 -319.144)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-66.64,3310.393h-3.833a.713.713,0,0,0-.712.713v.425l-3.974-.006,5.092-8.792a1.564,1.564,0,0,0-.618-2.164l-.092-.05a1.565,1.565,0,0,0-2.09.6l-5.954,10.281a2.168,2.168,0,0,0,1.873,3.255l5.761.008v.279a.712.712,0,0,0,.712.712h3.833a.712.712,0,0,0,.712-.712v-3.832A.713.713,0,0,0-66.64,3310.393Z",
    transform: "translate(0 -299.186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M135.564,3418.377l-6.344-3.777a.807.807,0,0,0-1.22.694v7.55a.806.806,0,0,0,1.22.693l6.344-3.774A.806.806,0,0,0,135.564,3418.377Z",
    transform: "translate(-192.199 -405.115)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 4.285,
    cy: 4.285,
    r: 4.285,
    transform: "translate(-50.877 2993.781)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M106.557,2991.4a2.556,2.556,0,0,0,2.371-3.512l3.339-5.766,5.868,10.195a1.565,1.565,0,0,0,2.141.573h0a1.564,1.564,0,0,0,.571-2.134l-6.758-11.74a2.168,2.168,0,0,0-3.755,0l-4.239,7.319a2.557,2.557,0,0,0,.462,5.071Z",
    transform: "translate(-169.928 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.505,3162.863l-5.764-3.328a.643.643,0,0,0-.878.235l-3.328,5.764a.643.643,0,0,0,.235.878l5.764,3.328a.642.642,0,0,0,.878-.234l3.328-5.765A.642.642,0,0,0,18.505,3162.863Z",
    transform: "translate(-81.258 -168.445)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaptedWhite);
export default __webpack_public_path__ + "static/media/adapted-white.265a108bc1d75ae2261f9c31808bfe7e.svg";
export { ForwardRef as ReactComponent };